module.exports = __webpack_public_path__ + "media/images/acad_council/sarah_greene-3a81c87e4378757474fed153d61dd2c2.jpg";